module.exports = "/static-assets/_next/static/images/apple-5892e3c4411ccce9acffc5fee05ce7fa.svg";